
    // this file was auto generated by python script
    import Navigation from './Navigation';
    export default Navigation;
    